import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight, BookOpen } from 'lucide-react';
import { blogPosts } from '../blogData';
import SafeImage from './SafeImage';
import { useSettings } from '../store';

const fmtDate = (d) => new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

const BlogPreview = () => {
  const settings = useSettings();
  const posts = blogPosts.slice(0, 3);
  return (
    <section className="py-14 bg-white">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
        <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
          <div>
            <div className="flex items-center gap-2 text-[#0d64a8] text-xs uppercase tracking-widest font-semibold mb-1">
              <BookOpen size={14} /> Travel Journal
            </div>
            <h2 className="text-3xl font-bold text-gray-900">
              {settings.section_blog_title || 'Guides & Stories'}
            </h2>
            <p className="text-sm text-gray-500 mt-1">Fresh trip ideas, first-hand advice and honest destination reviews.</p>
          </div>
          <Link to="/blog" className="text-sm text-[#0d64a8] font-medium inline-flex items-center gap-1 hover:gap-2 transition-all">
            Explore all articles <ArrowRight size={15} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              className="group bg-white rounded-xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="h-52 relative overflow-hidden">
                <SafeImage src={p.hero} alt={p.title} fallbackType={p.fbType} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <span className="absolute top-3 left-3 bg-white/95 backdrop-blur text-[#0d64a8] text-[11px] font-semibold px-2 py-0.5 rounded">{p.category}</span>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 text-[11px] text-gray-500 mb-2">
                  <span className="flex items-center gap-1"><Calendar size={11}/> {fmtDate(p.date)}</span>
                  <span>•</span>
                  <span className="flex items-center gap-1"><Clock size={11}/> {p.readTime}</span>
                </div>
                <h3 className="font-semibold text-gray-900 text-[17px] leading-snug group-hover:text-[#0d64a8] transition line-clamp-2 min-h-[46px]">
                  {p.title}
                </h3>
                <p className="text-sm text-gray-600 mt-2 line-clamp-2">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
